// extracted by mini-css-extract-plugin
export var contentWrapper = "about-layout-module--content-wrapper--Enk-F";